import React from "react";
import "./styles.scss";
import ResultItem from "./ResultItem";
import { getRound } from "../../../../utils/utils";
import { formatNumber } from "../../../../services/utility/utils";

export default function ResultNew(props: any) {
  const {
    contest,
    betAbove,
    lang,
    odds,
    isMinHeight,
    operatorId,
    isAbove,
    showTada,
    isShowLose,
  } = props;
  const isBet = contest?.position || "";
  return (
    <div className="parent-wrap-content-result">
      <div
        className={`wrap-content-result ${
          isMinHeight && "wrap-content-result-min"
        }

      animate__animated
      ${showTada && "animate__tada"}
      `}
        style={{
          opacity: isShowLose ? 0.2 : 1,
        }}
      >
        <ResultItem
          type="round"
          value={getRound(contest?.contestLiveTime)}
          lang={lang}
        />

        <ResultItem
          type="youBet"
          isBet={isBet}
          betAbove={betAbove}
          operatorId={operatorId}
          odds={odds}
          valueBet={contest?.wager}
          lang={lang}
        />

        <ResultItem
          type="lockPrice"
          lockPrice={contest?.livePrice || 0}
          lang={lang}
        />

        <ResultItem
          type="result"
          isAbove={isAbove}
          closePrice={contest?.closePrice}
          odds={formatNumber(
            Math.abs(contest?.closePrice - contest?.livePrice),
            2
          )}
          lang={lang}
        />
      </div>

      <div
        className={`
          wrap-result-lost animate__animated animate-delay-04
          ${isShowLose && "animate__fadeIn"}
        `}
      >
        {lang?.you_lose || "Better luck in the next round."}
      </div>
    </div>
  );
}
